import React from "react";
import { Building2, Car, Briefcase, PenTool, HardHat, Palette, PartyPopper, Plane, GraduationCap, HeartPulse, UtensilsCrossed, Sparkles, Dumbbell, Zap } from "lucide-react";

const MAP = { Building2, Car, Briefcase, PenTool, HardHat, Palette, PartyPopper, Plane, GraduationCap, HeartPulse, UtensilsCrossed, Sparkles, Dumbbell, Zap };

export default function CategoryIcon({ name, className }) {
  const Icon = MAP[name] || Briefcase;
  return <Icon className={className} />;
}
